import * as React from 'react';

const LocaleContext = React.createContext<string>('en');

export const Provider = LocaleContext.Provider;
export const Consumer = LocaleContext.Consumer;
export default LocaleContext;
